import { Integration } from "models/integration";


export function webhookUrl(integration: Integration) {
  return new URL(`/api/v1/webhooks/notify/${integration?.webhookId}`, process.env.BASE_URL).toString();
}
